import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Chip } from '@material-ui/core';

import { loadApplicantAutomations } from '../../../applicant-automations/actions/load-applicant-automations';
import { applicantAutomationsForOrgIdSelector } from '../../../applicant-automations/applicant-automation-selectors';

import { UiDialog } from '../../../ui/ui-dialog';

import { ApplicantAutomationMessage } from './applicant-automation-message';

import {
  getApplicationAutomationTiming,
  getFollowUpDetails,
  getTitleWithFallback,
} from '../../utils/applicant-automation-display-utils';

export const ViewDefaultDialog = ({
  overriddenAutomationId,
  orgId,
  orgName,
  onClose,
}: {
  overriddenAutomationId: number;
  orgId: number;
  orgName: string;
  onClose: () => void;
}) => {
  const automation = useSelector((state: any) =>
    (applicantAutomationsForOrgIdSelector(state, orgId) || []).find(
      (a) => a.applicantTriggeredCommunicationId === overriddenAutomationId,
    ),
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadApplicantAutomations({ orgId }));
  });

  if (!automation) {
    return null;
  }

  return (
    <UiDialog size="sm" title="Default Automation Details" onClose={onClose}>
      <UiDialog.Content>
        <div className="u-display-flex u-justifyContent-spaceBetween">
          <div className="u-textOverflow-ellipsis typo-title">
            {getTitleWithFallback(automation)}
          </div>
          <Chip
            size="small"
            label={automation.isActive ? 'Active' : 'Inactive'}
            className={automation.isActive ? 'u-color-white u-background-green' : ''}
          />
        </div>
        <div className="u-margin-top">
          <div className="typo-subtitle">{getApplicationAutomationTiming(automation)}</div>
          {!!automation.isOnlySendDuringBusinessHours && (
            <div className="typo-subtitle">This message will only send during business hours.</div>
          )}
          {!!automation.isFollowUp && (
            <div className="typo-subtitle">{getFollowUpDetails(automation)}</div>
          )}
          <ApplicantAutomationMessage automation={automation} orgName={orgName} />
        </div>
      </UiDialog.Content>
    </UiDialog>
  );
};
